import Vue from 'vue'
import axios from 'axios'

Vue.prototype.isDrugTaboo = false; //药品禁忌开关

import 'view-design/dist/styles/iview.css';
import ViewUI, {
    BackTop
} from 'view-design';
Vue.use(ViewUI);

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
Vue.use(PerfectScrollbar)

// 引导功能组件
import '@/com/intro/introjs.css';
import store from './store/index.js'

import './assets/css/app.css';
import './assets/css/user.css';
import './assets/css/phone.css';
import './assets/iconfont/iconfont.css'
import 'viewerjs/dist/viewer.css';
import 'highlight.js/styles/github.css';

import com from './com/index.js'
com(Vue);

import common from './common.js';
// 替换替换成<br>
Vue.prototype.newlineToBr = function (str) {
    if (str) return str.replace(/\n/g, '<br>');
}

import Print from './com/print/print.js'
Vue.use(Print)

import uEdition from "@/utils/uEdition.js";
Vue.directive('uEdition', uEdition);

import {
    Picker
} from 'vant';
Vue.use(Picker);

// 拖拽
import { initVDrag } from "@/directive/vDrag.js"
initVDrag(Vue)
// 缩放
import { initVWheelScale } from "@/directive/vWheelScale.js"
initVWheelScale(Vue)

import { hasSystemPerm } from '@/directive/permission/index.js';
hasSystemPerm(Vue)

Vue.prototype.confidenceProportionRed = config.confidenceProportionRed; //高亮红显置信度最低显视比例
Vue.prototype.confidenceProportion = config.confidenceProportion; //置信度最低显视比例
Vue.prototype.showCodeHosptialIds = config.showCodeHosptialIds; //显视处方支付码

Vue.prototype.uconfig = config
Vue.prototype.cloudPic = config.cloudPic;
Vue.prototype.picroot = function (url, type) {
    var bask = config.picBaseUrl3;
    let origin = location.origin;
    switch (type) {
        case 'symptom':
            bask = config.picBaseUrl2;
            break; //症状学习
        case 'archives':
            bask = config.picBaseUrl;
            break; //患者档案图片前缀
        case 'detail':
            bask = origin + "/Picture/His/";
            break; //病历详情
        case 'images':
            bask = config.picRoot + "/images/";
            break; //病历详情
        case 'acupoint':
            bask = config.picRootAcupoint;
            break; //上传图片的前缀
    }
    return bask + url;
}

Vue.prototype.isNew = (date_str) => {
    return new Date().getTime() <= new Date(date_str).getTime() + 1000 * 60 * 60 * 24 * 14;
}
import { hasAuth } from "@/utils/uEdition.js";
Vue.prototype.hasAuth = hasAuth;

// 调试工具
import vconsole from 'vconsole'
if (config.vconsole) var vc = new vconsole()

import api2 from '@/api/api2.js'
Vue.prototype.api2 = api2;

import request from '@/utils/request.js'
Vue.prototype.request = request;

function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

// 替换替换成<br>
Vue.prototype.newlineToBr = function (str) {
    if (str) return str.replace(/\n/g, '<br>');
}

Vue.prototype.isMobile = !IsPC();

// 是否Electron环境
Vue.prototype.isElectron = common.isElectron();

let obj = {
    axios,
    store,
    common
};
for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
        Vue.prototype[key] = obj[key];
    }
}
Vue.config.productionTip = false;

import App from './app.vue'

import VueBus from 'vue-bus';
Vue.use(VueBus);

Vue.prototype.versionType = config.versionType;

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: 'ba980c385ea208cd88eff8d84c4dc129',
    plugin: ['AMap.Autocomplete', 'AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});

// 正式环境才启用
/* 
import * as fundebug from "fundebug-javascript";
import FundebugVue from "fundebug-vue";
if (process.env.NODE_ENV != 'development') {
    fundebug.apikey = "744f887389f33f75f37ac39d1e10cab7a95e6e95510996b4a9e56a4a24eebc5e"
    new FundebugVue(fundebug).installVueErrorHandler(Vue); // Vue 2.x 
} */

import * as Sentry from "@sentry/vue";
import {
    BrowserTracing
} from "@sentry/tracing";

import router from './router'

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
    ops: {
        bar: {
            background: '#ccc'
        }
    }, // 在这里设置全局默认配置
});

// 关掉日志功能
/* if (config.isLog) { //是否启用日志
    Sentry.init({
        Vue,
        dsn: config.logApi,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ["localhost", "my-site-url.com", /^\//],
            }),
        ],
        tracesSampleRate: 1.0,
    });
} */

window.uApp = new Vue({
    router,
    store: store,
    render: h => h(App)
}).$mount('#app')